export const CAPTCHA_SITEKEY = '6LfdLrEoAAAAAJ7gxF9NeNIYC5b_eH1ektb7MvwK'